export const subcategories =
    [
        {
            key : "",
            value:""
        },
        {
            value: "سوپرمارکت و خواربار فروشی",
            key: 54110001
        },
        {
            value: "شرکت تولید و پخش مواد غذایی",
            key: 54110002
        },
        {
            value: "فروشگاه غلات و حبوبات",
            key: 54110003
        },
        {
            value: "فروشگاه زیتون، ترشی",
            key: 54110004
        },
        {
            value: "یخ فروشی",
            key: 54110005
        },
        {
            value: "تعاونی مصرف",
            key: 54110006
        },
        {
            value: "فروشنده چای و برنج",
            key: 54110007
        },
        {
            value: "فروش ادویه‌جات",
            key: 54110008
        },
        {
            value: "کشتارگاه",
            key: 54220001
        },
        {
            value: "قصابی و فروش محصولات گوشتی",
            key: 54220002
        },
        {
            value: "فرآورده گوشتی، همبرگر، سوسیس و کالباس",
            key: 54220004
        },
        {
            value: "فروش آبزیان",
            key: 54220005
        },
        {
            value: "قنادی و شیرینی فروشی",
            key: 54410001
        },
        {
            value: "خشکبار و آجیل فروش",
            key: 54410002
        },
        {
            value: "حلواساز و عصار",
            key: 54410003
        },
        {
            value: "عسل فروشی",
            key: 54410004
        },
        {
            value: "سوهان و گز",
            key: 54410005
        },
        {
            value: "زعفران فروشی",
            key: 54410006
        },
        {
            value: "فروشگاه شکلات و آب‌نبات",
            key: 54410007
        },
        {
            value: "فروشگاه چای و قهوه",
            key: 54410008
        },
        {
            value: "لوازم قنادی، کیک‌پزی و شیرینی پزی",
            key: 54410009
        },
        {
            value: "فروشگاه محصولات لبنی",
            key: 54510000
        },
        {
            value: "میوه فروشی و سبزی فروشی",
            key: 54990003
        },
        {
            value: "میدان میوه و تره بار",
            key: 54990004
        },
        {
            value: "بار فروشان عمده فروشی میوه و تره بار",
            key: 53000001
        },
        {
            value: "بنکدار مواد غذایی عمده فروش برنج",
            key: 53000002
        },
        {
            value: "بنکدار مواد غذایی عمده فروش چای",
            key: 53000003
        },
        {
            value: "بنکدار مواد غذایی عمده فروش روغن‌های خوراکی",
            key: 53000004
        },
        {
            value: "بنکدار مواد غذایی عمده فروش کلی",
            key: 53000005
        },
        {
            value: "آسیاب و عمده فروشی آرد",
            key: 53000006
        },
        {
            value: "کترینگ و تهیه غذا",
            key: 58110000
        },
        {
            value: "رستوران و سالن غذاخوری",
            key: 58120001
        },
        {
            value: "طباخان و فروشندگان کله، پاچه و سیرابی",
            key: 58120002
        },
        {
            value: "جگرکی",
            key: 58120003
        },
        {
            value: "سفره خانه",
            key: 58120004
        },
        {
            value: "کبابی، حلیم و آش",
            key: 58120005
        },
        {
            value: "چای خانه و قهوه خانه",
            key: 58140001
        },
        {
            value: "کافی شاپ و کافه تریا",
            key: 58140002
        },
        {
            value: "بستنی و آبمیوه فروشی",
            key: 58140003
        },
        {
            value: "رستوران‌های غذاهای آماده",
            key: 58140004
        },
        {
            value: "پیتزا، ساندویچ و فست فود",
            key: 58140005
        },
        {
            value: "فروشگاه زنجیره ای بزرگ",
            key: 53110001
        },
        {
            value: "نانوایی سنتی",
            key: 54620001
        },
        {
            value: "نان صنعتی، حجیم و نیمه حجیم",
            key: 54630001
        },
        {
            value: "کلوچه و نان شیرین (خشکه پزی)",
            key: 54630002
        },
        {
            value: "فروشگاه سیگار و محصولات دخانی",
            key: 59930001
        },
        {
            value: "عمده فروشی و پخش سیگار و محصولات دخانی",
            key: 59930002
        },
        {
            value: "دامداری و دامپروری",
            key: 7630001
        },
        {
            value: "کشاورزی و باغداری",
            key: 7630002
        },
        {
            value: "پرورش طیور",
            key: 7630003
        },
        {
            value: "پرورش زنبور عسل",
            key: 7630004
        },
        {
            value: "پرورش ماهی و آبزی پروری",
            key: 7630005
        },
        {
            value: "پرورش و تولید قارچ",
            key: 7630006
        },
        {
            value: "فروشگاه لوازم کشاورزی و دامداری",
            key: 7630007
        },
        {
            value: "فروش دام",
            key: 7630008
        },
        {
            value: "عمده فروشی و پخش گل و گیاه",
            key: 51930001
        },
        {
            value: "عمده فروشی و پخش لوازم گلفروشی",
            key: 51930002
        },
        {
            value: "مواد اولیه و لوازم کشاورزی و باغبانی",
            key: 52610001
        },
        {
            value: "لوازم آبیاری و آبرسانی کشاورزی و صنعتی",
            key: 52610002
        },
        {
            value: "فروشندگان نهال",
            key: 52610003
        },
        {
            value: "گلفروشی",
            key: 59920001
        },
        {
            value: "فروش گیاهان آپارتمانی و درختچه تزئینی",
            key: 59920002
        },
        {
            value: "فروشندگان پرنده، ماهی و حیوانات خانگی",
            key: 59950001
        },
        {
            value: "فروشگاه غذا و لوازم حیوانات خانگی (پت شاپ)",
            key: 59950002
        },
        {
            value: "فروش کود، سم و داروهای شیمیایی محصولات کشاورزی",
            key: 73420001
        },
        {
            value: "ارائه انواع خدمات سمپاشی و ضدعفونی",
            key: 73420002
        },
        {
            value: "سردخانه و انبار محصولات کشاورزی",
            key: 42250001
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "عمده‌فروشی و پخش یونیفرم و لباس کار",
            key: 51370000
        },
        {
            value: "فروشگاه پوشاک نوزاد و کودک",
            key: 56410001
        },
        {
            value: "لوازم نوزاد و سیسمونی",
            key: 56410002
        },
        {
            value: "فروشگاه پوشاک خانواده",
            key: 56510001
        },
        {
            value: "فروشگاه لباس مجلسی و عروس",
            key: 56510002
        },
        {
            value: "مانتو ، پالتو و یونیفرم اداری",
            key: 56510003
        },
        {
            value: "پوشاک زنانه",
            key: 56510004
        },
        {
            value: "فروشگاه کت و شلوار و پیراهن",
            key: 56510005
        },
        {
            value: "فروشگاه پوشاک مردانه",
            key: 56510006
        },
        {
            value: "فروشگاه یونیفرم و لباس نظامی",
            key: 56510007
        },
        {
            value: "فروشگاه لباس زیر زنانه و مردانه",
            key: 56510008
        },
        {
            value: "فروشگاه لباس ورزشی",
            key: 56550001
        },
        {
            value: "فروشگاه تخصصی پوشاک و لوازم سوارکاری",
            key: 56550002
        },
        {
            value: "فروشگاه تخصصی فروش کفش ورزشی",
            key: 56550003
        },
        {
            value: "فروشگاه پوشاک پوستین و خز",
            key: 56810001
        },
        {
            value: "پوشاک و اکسسوری چرم",
            key: 56810002
        },
        {
            value: "جوراب فروشی",
            key: 56990001
        },
        {
            value: "دستکش، کلاه، شال گردن، حوله ...",
            key: 56990002
        },
        {
            value: "منسوجات و کالای کشباف",
            key: 56990003
        },
        {
            value: "لوازم و تزئینات سفره عقد (خنچه عقد)",
            key: 56990004
        },
        {
            value: "خدمات اجاره انواع لباس",
            key: 72960001
        },
        {
            value: "اجاره لباس عروس و شب",
            key: 72960002
        },
        {
            value: "عمده‌فروشی و پخش کفش ماشینی و کار",
            key: 51390001
        },
        {
            value: "عمده‌فروشی و پخش کفش",
            key: 51390002
        },
        {
            value: "عمده‌فروشی و پخش کیف",
            key: 51390003
        },
        {
            value: "عمده‌فروشی و پخش کیف و کفش",
            key: 51390004
        },
        {
            value: "عمده فروشی لوازم کفاشی",
            key: 51390005
        },
        {
            value: "شال و روسری فروشی",
            key: 56310001
        },
        {
            value: "فروشگاه بدلیجات تزئینی (اکسسوری)",
            key: 56310002
        },
        {
            value: "فروشگاه محصولات حجاب",
            key: 56310003
        },
        {
            value: "کیف و کفش فروشی",
            key: 56610001
        },
        {
            value: "کیف فروشی",
            key: 56610002
        },
        {
            value: "کفش فروشی",
            key: 56610003
        },
        {
            value: "ساک و چمدان",
            key: 59480000
        },
        {
            value: "کفاشی",
            key: 72510001
        },
        {
            value: "تعمیرات انواع کیف",
            key: 72510002
        },
        {
            value: "عمده فروشان لوازم خیاطی و دوزندگی",
            key: 51310001
        },
        {
            value: "بنکدار و طاقه فروش پارچه و پرده",
            key: 51310002
        },
        {
            value: "عمده فروشان پتو و روتختی",
            key: 51310003
        },
        {
            value: "خیاطی و تعمیرات لباس",
            key: 56970001
        },
        {
            value: "تولیدی مانتو شلوار و لباس زنانه",
            key: 56970002
        },
        {
            value: "دوخت لباس عروس و شب",
            key: 56970003
        },
        {
            value: "تولیدی کت و شلوار و لباس مردانه",
            key: 56970004
        },
        {
            value: "گونی و کیسه دوزی",
            key: 56970005
        },
        {
            value: "نساجی و ریسندگی",
            key: 56970006
        },
        {
            value: "رنگرزی و صباغی",
            key: 56970007
        },
        {
            value: "دوزندگی لوازم ایمنی و لباس کار",
            key: 56970008
        },
        {
            value: "دوزندگی لباس نظامی",
            key: 56970009
        },
        {
            value: "لوازم خیاطی، لوازم گل دوزی و سوزن دوزی",
            key: 59490001
        },
        {
            value: "پارچه فروشان",
            key: 59490003
        },
        {
            value: "فروشندگان نخ، کاموا و لوازم بافندگی",
            key: 59490004
        },
        {
            value: "تشک، پتو و کالای خواب (روتختی، ملحفه...)",
            key: 59490005
        },
        {
            value: "خرازی و فروشندگان لوازم ارزان",
            key: 53310001
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "خدمات چمن‌کاری و فضای سبز",
            key: 7800001
        },
        {
            value: "تعاونی مسکن",
            key: 15200001
        },
        {
            value: "شرکت ساختمانی و انبوه سازی",
            key: 15200002
        },
        {
            value: "ارائه دهندگان خدمات مشارکت در ساخت",
            key: 15200003
        },
        {
            value: "تاسیسات ساختمان (لوله کشی،سرمایشی،گرمایشی)",
            key: 17110001
        },
        {
            value: "لوله بازکنی و تشخیص ترکیدگی لوله",
            key: 17110002
        },
        {
            value: "تخلیه کنندگان چاه و فاضلاب",
            key: 17110003
        },
        {
            value: "سیستم حرارتی، برودتی و تهویه مطبوع",
            key: 17110004
        },
        {
            value: "کانال سازی و کانال کشی ساختمان",
            key: 17110005
        },
        {
            value: "الکتروموتور،سیم پیچ و ژنراتور",
            key: 17310001
        },
        {
            value: "سیم کشی برق و تلفن",
            key: 17310002
        },
        {
            value: "تاسیسات برقی ساختمان",
            key: 17310005
        },
        {
            value: "بنایی و معماری",
            key: 17400001
        },
        {
            value: "ایزوگام عایق‌کاری سقف و دیوار",
            key: 17400002
        },
        {
            value: "سیمانکاری",
            key: 17400003
        },
        {
            value: "نقاش ساختمان",
            key: 17400004
        },
        {
            value: "کاشی‌کاری و سرامیک‌کاری و نصب پارکت و کفپوش",
            key: 17400005
        },
        {
            value: "فخاران تولید آجر و گچ",
            key: 17400006
        },
        {
            value: "نماسازی ساختمان",
            key: 17400007
        },
        {
            value: "گچ‌کاری",
            key: 17400008
        },
        {
            value: "نجاری و درودگری",
            key: 17500001
        },
        {
            value: "خاتم کاری، منبت کاری و مصنوعات چوبی",
            key: 17500002
        },
        {
            value: "ساخت در و پنجره چوبی",
            key: 17500003
        },
        {
            value: "پوشش سقف",
            key: 17610001
        },
        {
            value: "نصب شیروانی، گاتر و آبرو",
            key: 17610002
        },
        {
            value: "کناف کاری",
            key: 17610003
        },
        {
            value: "آسفالت کاری",
            key: 17710001
        },
        {
            value: "بتن‌ ریزی",
            key: 17710002
        },
        {
            value: "داربست و اتصالات فلزی",
            key: 17990001
        },
        {
            value: "لوله و اتصالات ساختمانی",
            key: 17990002
        },
        {
            value: "خدمات دکور و معماری داخلی ساختمان",
            key: 17990003
        },
        {
            value: "سوله سازی",
            key: 17990004
        },
        {
            value: "آسانسور و بالابر برقی",
            key: 17990005
        },
        {
            value: "گودبرداری ساختمان",
            key: 17990006
        },
        {
            value: "خدمات تخریب ساختمان",
            key: 17990007
        },
        {
            value: "ساخت و نصب در و کرکره اتومات",
            key: 17990008
        },
        {
            value: "ساخت در و پنجره فلزی",
            key: 17990009
        },
        {
            value: "تولید و نصب آلاچیق",
            key: 17990010
        },
        {
            value: "عمده فروشی و پخش مصالح ساختمانی",
            key: 50390000
        },
        {
            value: "کابینت آشپزخانه",
            key: 52000001
        },
        {
            value: "فروشگاه‌ تزئینات داخلی ساختمان",
            key: 52000002
        },
        {
            value: "فروشگاه موزاییک، کاشی و سرامیک و سنگ، پارکت و کفپوش",
            key: 52110001
        },
        {
            value: "فروشگاه چوب، الوار، مصالح چوبی و پوشش سقف",
            key: 52110002
        },
        {
            value: "فروش سیمان، شن و ماسه، آجر و گچ",
            key: 52110003
        },
        {
            value: "ابزار و یراق آلات ساختمانی (دستگیره، پریز و ...)",
            key: 52110004
        },
        {
            value: "گاتر و آبروها",
            key: 52110005
        },
        {
            value: "بلوک، جدول و مصنوعات سیمانی",
            key: 52110006
        },
        {
            value: "کاغذ دیواری و تزیینات داخلی ساختمان",
            key: 52310001
        },
        {
            value: "شیشه‌بری و فروشندگی شیشه و آیینه",
            key: 52310002
        },
        {
            value: "آهنگری",
            key: 76920000
        },
        {
            value: "خدمات معماری، مهندسی و نقشه‌برداری",
            key: 89110001
        },
        {
            value: "خدمات نظام مهندسی",
            key: 89110002
        },
        {
            value: "ساخت و مونتاژ خانه‌های پیش ساخته قابل حمل و کانکس",
            key: 52710000
        },
        {
            value: "خدمات آزمون و لابراتور برای سایر کسب وکارها",
            key: 87340000
        },
        {
            value: "فروش تجهیزات استخرهای خانگی، جکوزی، وان",
            key: 59960000
        },
        {
            value: "صندلی آمفی تئاتر، غرفه سازی و امور نمایشگاهی",
            key: 50210001
        },
        {
            value: "مبلمان اداری",
            key: 50210002
        },
        {
            value: "مبلمان شهری، مجوعه های بازی، ایستگاه اتوبوس و تاکسی",
            key: 50210003
        },
        {
            value: "مبلمان خانگی",
            key: 57120001
        },
        {
            value: "سرویس خواب بزرگسال",
            key: 57120002
        },
        {
            value: "سرویس خواب نوزاد، کودک و نوجوان",
            key: 57120003
        },
        {
            value: "کالای چوب",
            key: 57120004
        },
        {
            value: "فرش دستبافت، گلیم و تابلو فرش",
            key: 57130001
        },
        {
            value: "فرش ماشینی و موکت",
            key: 57130002
        },
        {
            value: "دوخت، نصب و تعمیر انواع پرده",
            key: 57140001
        },
        {
            value: "فروشگاه انواع پرده و لوازم جانبی",
            key: 57140002
        },
        {
            value: "فروشگاه پارچه پرده ای",
            key: 57140003
        },
        {
            value: "فروشگاه پارچه مبلی ",
            key: 57140004
        },
        {
            value: "فروش شومینه، آتشدان، باربیکیو و لوازم جانبی",
            key: 57180000
        },
        {
            value: "فروشندگان لوستر، آباژور، آیینه و شمعدان و قاب عکس",
            key: 57190001
        },
        {
            value: "لوازم و ظروف آشپزخانه",
            key: 57190002
        },
        {
            value: "فروشندگان اجناس سفالی و سرامیکی",
            key: 57190003
        },
        {
            value: "فروشگاه ظروف پلاستیکی (پلاسکو)",
            key: 57190004
        },
        {
            value: "لوازم بسته بندی و ظروف یکبار مصرف",
            key: 57190005
        },
        {
            value: "دکوری و تزئینی (مجسمه، شمع و...)",
            key: 57190006
        },
        {
            value: "فروشندگان لوازم خانگی برقی",
            key: 57220001
        },
        {
            value: "فروش چرخ خیاطی",
            key: 57220002
        },
        {
            value: "فروشگاه صوتی و تصویری",
            key: 57220003
        },
        {
            value: "فروش دستگاه های تصفیه آب",
            key: 57220004
        },
        {
            value: "کریستال،چینی، بلورفروشی، لوازم کادویی و کالای لوکس",
            key: 59500001
        },
        {
            value: "تعمیرکاران لوازم صوتی و تصویری",
            key: 76220001
        },
        {
            value: "تعمیرکاران لوازم برقی خانگی (به جز یخچال و فریزر)",
            key: 76220002
        },
        {
            value: "تعمیرکاران یخچال، فریز",
            key: 76230001
        },
        {
            value: "تعمیرکاران کولرهای گازی، هواساز و دستگاه‌های تهویه هوا",
            key: 76230002
        },
        {
            value: "تعمیرات و رویه‌کوبی مبلمان",
            key: 76410000
        },
        {
            value: "اجاره لوازم برگزاری مجالس و مبلمان",
            key: 73940001
        },
        {
            value: "خدمات اجاره زیورآلات",
            key: 73940002
        },
        {
            value: "اجاره لوازم و تجهیزات صنعتی",
            key: 73940003
        },
        {
            value: "اجاره لوازم سفر، کمپینگ و سرگرمی",
            key: 73940004
        },
        {
            value: "تعمیر لوازم ورزشی",
            key: 76990002
        },
        {
            value: "تعمیر ماشین چاپ",
            key: 76990003
        },
        {
            value: "تعمیرکاران لوازم شخصی برقی (ریش تراش، اتو مو ...)",
            key: 76990004
        },
        {
            value: "مشاورین املاک و مستغلات",
            key: 65130000
        },
        {
            value: "اجاره انبار و سوله",
            key: 65130001
        },
        {
            value: "فروشندگان آهن‌آلات ساختمانی، میلگرد، نبشی و ورق",
            key: 50510001
        },
        {
            value: "ضایعات فلزی و غیرفلزی",
            key: 50510002
        },
        {
            value: "تراشکاری و فلزکاری",
            key: 50510003
        },
        {
            value: "لعاب کاری و رنگ کاری فلزات",
            key: 50510004
        },
        {
            value: "فروش فرفورژه",
            key: 50510005
        },
        {
            value: "ذوب فلزات،ریخته گری و قالب سازی",
            key: 50510006
        },
        {
            value: "آلومینیوم و مصنوعات نوردی آن",
            key: 50510007
        },
        {
            value: "مس و مصنوعات مسی",
            key: 50510008
        },
        {
            value: "پرسکاری فلزات",
            key: 50510009
        },
        {
            value: "فروشندگان عمده تجهیزات و قطعات الکتریکی",
            key: 50650001
        },
        {
            value: "تابلوسازان و موسسات برق صنعتی",
            key: 50650002
        },
        {
            value: "تولید کننده لوازم برقی و بردهای الکترونیکی",
            key: 50650003
        },
        {
            value: "عمده‌فروشی و پخش ابزار و یراق‌آلات",
            key: 50720001
        },
        {
            value: "فروشندگان عمده تجهیزات لوله‌کشی، شوفاژ و تهویه مطبوع",
            key: 50740000
        },
        {
            value: "عمده فروشی و پخش ملزومات صنعتی (نامذکور در کدهای دیگر)",
            key: 50850000
        },
        {
            value: "عمده فروشی و پخش رنگ، جلا و مواد مصرفی نقاشی",
            key: 51980000
        },
        {
            value: "ابزارفروشان",
            key: 52510001
        },
        {
            value: "پیچ و مهره فروشان",
            key: 52510002
        },
        {
            value: "فروشگاه قفل و لولا و یراق‌آلات",
            key: 52510003
        },
        {
            value: "قفل و کلیدسازی",
            key: 52510004
        },
        {
            value: "فروش تجهیزات و قطعات الکتریکی",
            key: 52510005
        },
        {
            value: "تجهیزات پخت و پز رستوران‌ها",
            key: 50460001
        },
        {
            value: "تولید و فروش مانکن",
            key: 50460002
        },
        {
            value: "تجهیزات پخت و پز تجاری",
            key: 50460003
        },
        {
            value: "سمعی و بصری (کمک اموزشی)",
            key: 50460004
        },
        {
            value: "مخازن و تانکرهای صنعتی و غیر صنعتی",
            key: 50460005
        },
        {
            value: "فروشگاه ملزومات ایمنی و اطفای حریق",
            key: 50990001
        },
        {
            value: "نصابان سیستم‌های اطفا حریق",
            key: 50990002
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "لاستیک فروشی",
            key: 55320000
        },
        {
            value: "عمده‌فروشی و پخش لوازم یدکی خودرو",
            key: 50130001
        },
        {
            value: "عمده‌فروشی و پخش لوازم موتورسیکلت",
            key: 50130002
        },
        {
            value: "عمده‌فروشی و پخش لوازم ماشین‌الات سنگین",
            key: 50130003
        },
        {
            value: "شرکت خودروسازی",
            key: 55110001
        },
        {
            value: "نمایشگاه‌ خودرو",
            key: 55210001
        },
        {
            value: "لیزینگ خودرو",
            key: 55210002
        },
        {
            value: "فروشندگان لوازم یدکی خودرو",
            key: 55330001
        },
        {
            value: "تزئینات اتومبیل و نصب دزدگیر",
            key: 55330002
        },
        {
            value: "تشکدوزان و صندلی سازان اتومبیل",
            key: 55330003
        },
        {
            value: "فروش لوازم یدکی موتورسیکلت",
            key: 55330004
        },
        {
            value: "فروش لوازم یدکی ماشین‌آلات سنگین",
            key: 55330005
        },
        {
            value: "فروشگاه‌ موتورسیکلت",
            key: 55710001
        },
        {
            value: "فروش و خدمات ماشین آلات حفاری",
            key: 55990001
        },
        {
            value: "فروش و خدمات ماشین آلات راه سازی و ساختمانی",
            key: 55990002
        },
        {
            value: "فروش و خدمات ماشین آلات و ادوات کشاورزی",
            key: 55990003
        },
        {
            value: "فروش و خدمات ماشین آلات صنعتی",
            key: 55990004
        },
        {
            value: "فروش و خدمات ماشین آلات چاپ و صحافی",
            key: 55990005
        },
        {
            value: "فروش و خدمات ماشین آلات مرغداری",
            key: 55990006
        },
        {
            value: "فروش و خدمات ماشین آلات تراشکاری",
            key: 55990007
        },
        {
            value: "باسکول‌داری",
            key: 55990008
        },
        {
            value: "فروش جرثقیل",
            key: 55990009
        },
        {
            value: "فروش و خدمات لیفتراک",
            key: 55990010
        },
        {
            value: "اجاره ماشین بدون/با راننده",
            key: 75120000
        },
        {
            value: "اجاره دهندگان کامیون و تریلر و ماشین‌آلات سنگین",
            key: 75130000
        },
        {
            value: "پارکینگ و گاراژ",
            key: 75230000
        },
        {
            value: "صافکاری و گلگیرسازی خودرو",
            key: 75310000
        },
        {
            value: "تعمیرکاران لاستیک خودرو (آپاراتی)",
            key: 75340000
        },
        {
            value: "نقاشی اتومبیل",
            key: 75350000
        },
        {
            value: "اگزوزسازی",
            key: 75380001
        },
        {
            value: "اطاق سازی و باربند سازی خودرو",
            key: 75380002
        },
        {
            value: "خدمات برق اتومبیل، باطری ساز و باطری فروش",
            key: 75380003
        },
        {
            value: "مکانیکی و تعمیر خودرو",
            key: 75380004
        },
        {
            value: "سپرسازی خودرو",
            key: 75380005
        },
        {
            value: "تعویض روغن خودرو",
            key: 75380006
        },
        {
            value: "تعمیرگاه موتور سیکلت",
            key: 75380007
        },
        {
            value: "کارواش",
            key: 75420000
        },
        {
            value: "یدک‌کشی و بکسل خودرو",
            key: 75490000
        },
        {
            value: "انبار اوراق خودرو",
            key: 59350000
        },
        {
            value: "فروش قایق و کشتی",
            key: 55510000
        },
        {
            value: "فروش جت اسکی",
            key: 55510001
        },
        {
            value: "فروشگاه‌ دوچرخه",
            key: 59400001
        },
        {
            value: "فروش لوازم یدکی دوچرخه",
            key: 59400002
        },
        {
            value: "تعمیرات دوچرخه",
            key: 59400003
        },
        {
            value: "خدمات نگهداری و تعمیرات قایق و کشتی",
            key: 44680000
        },
        {
            value: "خدمات عملیات و نگهداری فرودگاه و سایت پروازی",
            key: 45820000
        },
        {
            value: "دفاتر و ادارات پست دولتی",
            key: 94020000
        },
        {
            value: "خطوط ریلی باری",
            key: 40110000
        },
        {
            value: "قطار شهری (مترو)",
            key: 41110001
        },
        {
            value: "حمل و نقل قایق و کشتی مسافری",
            key: 41110002
        },
        {
            value: "راه آهن مسافربری",
            key: 41120000
        },
        {
            value: "تاکسی فرودگاه",
            key: 41210001
        },
        {
            value: "تاکسی اینترنتی",
            key: 41210002
        },
        {
            value: "تاکسی تلفنی",
            key: 41210003
        },
        {
            value: "پایانه‌های اتوبوسی بین شهری",
            key: 41310001
        },
        {
            value: "پایانه اتوبوسی شهری",
            key: 41310002
        },
        {
            value: "خدمات باربری هوایی",
            key: 42140001
        },
        {
            value: "خدمات باربری با کامیون و وانت",
            key: 42140002
        },
        {
            value: "خدمات پیک و ارسال مرسولات",
            key: 42150000
        },
        {
            value: "آژانس فروش بلیط",
            key: 45110001
        },
        {
            value: "فروش بلیط اینترنتی",
            key: 45110002
        },
        {
            value: "عوارض راه",
            key: 47840000
        },
        {
            value: "خدمات حمل و نقل (نامذکور در کدهای دیگر)",
            key: 47890000
        },
        {
            value: "عمده فروشان مواد شیمیایی و آلی",
            key: 51690001
        },
        {
            value: "عمده فروشان مواد، مصنوعات پلاستیکی و نایلون",
            key: 51690002
        },
        {
            value: "عمده فروشان گازهای صنعتی",
            key: 51690003
        },
        {
            value: "عمده فروشی و پخش نفت خام و مشتقات",
            key: 51720000
        },
        {
            value: "جایگاه بنزین",
            key: 55420001
        },
        {
            value: "جایگاه CNG",
            key: 55420002
        },
        {
            value: "جایگاه گازوئیل",
            key: 55420003
        },
        {
            value: "فروش چوب؛ ذغال سنگ و سایر سوخت های جامد",
            key: 59830001
        },
        {
            value: "فروش نفت به مصرف کنندگان",
            key: 59830002
        },
        {
            value: "فروش سوخت هواپیما",
            key: 59830003
        },
        {
            value: "فروش سوخت قایق و کشتی",
            key: 59830004
        },
        {
            value: "توزیع کنندگان و شارژ کپسول گاز",
            key: 59830005
        },
        {
            value: "اداره برق و قبوض",
            key: 49000001
        },
        {
            value: "اداره گاز و قبوض",
            key: 49000002
        },
        {
            value: "اداره آب و فاضلاب و قبوض",
            key: 49000003
        },
        {
            value: "اداره مخابرات و قبوض",
            key: 49000004
        },
        {
            value: "جایگاه‌ شارژ خودروهای برقی",
            key: 55520001
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "خدمات آمبولانس و حمل بیمار",
            key: 41190000
        },
        {
            value: "تجهیزات و لوازم پزشکی، بیمارستانی و آزمایشگاهی",
            key: 50470001
        },
        {
            value: "تجهیزات و لوازم دندانپزشکی",
            key: 50470002
        },
        {
            value: "فروش لوازم و تجهیزات پزشکی، آزمایشگاهی، بیمارستانی و دندانپزشکی",
            key: 50470003
        },
        {
            value: "تعمیرکنندگان لوازم و تجهیزات پزشکی، آزمایشگاهی، بیمارستانی و دندانپزشکی",
            key: 50470004
        },
        {
            value: "ابزار سلامت و طب (محافظ طبی، ماساژور، دستگاه بخور و...)",
            key: 50470005
        },
        {
            value: "لوازم ارتوپدي پزشکي و اعضا مصنوعي",
            key: 50470006
        },
        {
            value: "لوازم کمک شنوايي پزشکي (سمعک)",
            key: 50470007
        },
        {
            value: "عمده فروشی و پخش دارو و محصولات آرایشی",
            key: 51220001
        },
        {
            value: "عمده‌فروشی و پخش لوازم آرایشی",
            key: 51220002
        },
        {
            value: "عمده‌فروشی و پخش عطر و ادکلن",
            key: 51220003
        },
        {
            value: "داروخانه",
            key: 59120001
        },
        {
            value: "عطاری",
            key: 59150001
        },
        {
            value: "خدمات کفن و دفن",
            key: 72610000
        },
        {
            value: "پزشکان عمومی",
            key: 80110001
        },
        {
            value: "خدمات دندانپزشکی",
            key: 80210001
        },
        {
            value: "ارتودنسی",
            key: 80210002
        },
        {
            value: "پزشکان طب سنتی",
            key: 80330001
        },
        {
            value: "رادیولوژی و سنوگرافی",
            key: 80440001
        },
        {
            value: "عکس برداری هسته ای",
            key: 80440002
        },
        {
            value: "ماموگرافی",
            key: 80440003
        },
        {
            value: "چشم‌پزشک و بینایی‌سنجی",
            key: 80420000
        },
        {
            value: "خدمات عینک و لنز",
            key: 80430000
        },
        {
            value: "سایر کسب و کارهای مرتبط با این گروه صنفی",
            key: 80320000
        },
        {
            value: "کلینیک تخصصی پوست و مو",
            key: 80320001
        },
        {
            value: "مغز و اعصاب",
            key: 80320002
        },
        {
            value: "قلب و عروق",
            key: 80320003
        },
        {
            value: "پوست و مو",
            key: 80320004
        },
        {
            value: "زنان و زایمان",
            key: 80320005
        },
        {
            value: "ارتوپدی",
            key: 80320006
        },
        {
            value: "اورولوژی",
            key: 80320007
        },
        {
            value: "اطفال",
            key: 80320008
        },
        {
            value: "داخلی",
            key: 80320009
        },
        {
            value: "گوارش",
            key: 80320010
        },
        {
            value: "گوش، حلق، بینی",
            key: 80320011
        },
        {
            value: "روانپزشک",
            key: 80320012
        },
        {
            value: "انکولوژی",
            key: 80320013
        },
        {
            value: "ریه",
            key: 80320014
        },
        {
            value: "غدد",
            key: 80320015
        },
        {
            value: "پلاستیک و زیبایی",
            key: 80320016
        },
        {
            value: "پا پزشکی",
            key: 80320017
        },
        {
            value: "بیمارستان حیوانات",
            key: 7420001
        },
        {
            value: "کلینیک حیوانات خانگی",
            key: 7420002
        },
        {
            value: "پانسیون حیوانات",
            key: 7420003
        },
        {
            value: "خدمات درمانی دام و طیور",
            key: 7420004
        },
        {
            value: "داروخانه دامپزشکی",
            key: 7420005
        },
        {
            value: "خانه سالمندان",
            key: 80500001
        },
        {
            value: "خدمات پرستاری و مراقبت‌های فردی",
            key: 80500002
        },
        {
            value: "پرستاران کودک",
            key: 80500003
        },
        {
            value: "بیمارستان‌ دولتی",
            key: 80620001
        },
        {
            value: "بیمارستان‌ خصوصی",
            key: 80620002
        },
        {
            value: "درمانگاه",
            key: 80620003
        },
        {
            value: "تزریقات",
            key: 80620004
        },
        {
            value: "آزمایشگاه‌های پاتولوژی",
            key: 80710001
        },
        {
            value: "لابراتوارهای دندانپزشکی",
            key: 80710002
        },
        {
            value: "سازمان انتقال خون",
            key: 80990001
        },
        {
            value: "کلینیک ترک اعتیاد",
            key: 80990002
        },
        {
            value: "لیزر و زیبایی",
            key: 80990003
        },
        {
            value: "خدمات فیزیوتراپی",
            key: 80990004
        },
        {
            value: "تغذیه و رژیم درمانی",
            key: 80990005
        },
        {
            value: "طب سوزنی",
            key: 80990006
        },
        {
            value: "طب کار",
            key: 80990007
        },
        {
            value: "مامایی",
            key: 80990008
        },
        {
            value: "کایروپراکتور",
            key: 80990009
        },
        {
            value: "خدمات مشاوره ازدواج",
            key: 72770001
        },
        {
            value: "خدمات روانشناسی و روانکاوی و گفتار درمانی",
            key: 72770002
        },
        {
            value: "فروشگاه مواد شوینده و بهداشتی",
            key: 28420001
        },
        {
            value: "عمده فروشی و پخش مواد شوینده و پاک کننده",
            key: 28420002
        },
        {
            value: "خشکشویی",
            key: 72160000
        },
        {
            value: "قالی‌شویی، مرمت و رفوگری فرش",
            key: 72170000
        },
        {
            value: "خدمات نظافت، نگهداری و سرایداری",
            key: 73490000
        },
        {
            value: "فروشگاه لوازم آرایشی و بهداشتی",
            key: 59770001
        },
        {
            value: "عطر و ادکلن",
            key: 59770002
        },
        {
            value: "فروش روغن های مراقبتی و درمانی",
            key: 59770003
        },
        {
            value: "فروشگاه موي مصنوعي و کلاه گيس",
            key: 59770004
        },
        {
            value: "آرایشگاه مردانه",
            key: 72300001
        },
        {
            value: "سالن‌های زیبایی و آرایشگاه‌های زنانه",
            key: 72300002
        },
        {
            value: "سالن ماساژ درمانی",
            key: 72970001
        },
        {
            value: "اسپا",
            key: 72970002
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "سازمان تامین اجتماعی",
            key: 63000000
        },
        {
            value: "شرکت‌های بیمه",
            key: 59600001
        },
        {
            value: "کارگزاری‌ها و نمایندگان بیمه",
            key: 59600002
        },
        {
            value: "مزایده",
            key: 53100000
        },
        {
            value: "بانک ها و موسسات مالی و اعتباری مجاز",
            key: 60100000
        },
        {
            value: "صندوق های قرض الحسنه دارای مجوز",
            key: 60120000
        },
        {
            value: "کارگزاری‌ها",
            key: 62110000
        },
        {
            value: "شرکت‌های سبدگردان",
            key: 62120001
        },
        {
            value: "صندوق‌های سرمایه‌گذاری",
            key: 62120002
        },
        {
            value: "مؤسسات اعتبارسنجی",
            key: 73210000
        },
        {
            value: "خدمات حسابداری، حسابرسی و دفترداری",
            key: 89310000
        },
        {
            value: "خدمات پرداخت الکترونیکی (پرداخت یاری)",
            key: 98020000
        },
        {
            value: "صرافی",
            key: 60510000
        },
        {
            value: "کسب و کارهای مرتبط با فناوری زنجیره بلوک",
            key: 78000001
        },
        {
            value: "کیف الکترونیک پول",
            key: 65400001
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "انجمن‌ها و اتحادیه‌های مدنی، اجتماعی و برادری",
            key: 86410000
        },
        {
            value: "احزاب و سازمان های سیاسی",
            key: 86510000
        },
        {
            value: "هیئت مذهبی، حسینه، مساجد، مصلی",
            key: 86610001
        },
        {
            value: "دفاتر امام جمعه و مراجع",
            key: 86610002
        },
        {
            value: "حوزه علمیه و مدارس دینی",
            key: 86610003
        },
        {
            value: "سایر سازمان‌ها و اتحادیه‌ها (نامذکور در کدهای دیگر)",
            key: 86990000
        },
        {
            value: "آژانس کاریابی",
            key: 73610000
        },
        {
            value: "شرکت‌های مشاوره مدیریت",
            key: 73920000
        },
        {
            value: "دفاتر ثبت ازدواج و طلاق",
            key: 81110001
        },
        {
            value: "دفاتر وکالت",
            key: 81110002
        },
        {
            value: "برگزاری همایش و سمینار",
            key: 73990001
        },
        {
            value: "دارالترجمه رسمی",
            key: 73990002
        },
        {
            value: "خدمات بازرگانی وارادت و صادرات",
            key: 73990003
        },
        {
            value: "حمام عمومی و گرمابه داران",
            key: 89990003
        },
        {
            value: "حفر چاه عمیق و نیمه عمیق",
            key: 89990005
        },
        {
            value: "خدمات مهاجرت و ویزا",
            key: 89990006
        },
        {
            value: "عریضه نویسی",
            key: 73390000
        },
        {
            value: "شورای حل اختلاف",
            key: 92110001
        },
        {
            value: "دادگاه و خدمات قضایی و دادرسی",
            key: 92110002
        },
        {
            value: "جرایم",
            key: 92220000
        },
        {
            value: "ادارات گمرک",
            key: 93110001
        },
        {
            value: "سازمان امور مالیاتی",
            key: 93110002
        },
        {
            value: "دفاتر ثبت اسناد رسمی",
            key: 93990001
        },
        {
            value: "دفاتر پیشخوان دولت",
            key: 93990002
        },
        {
            value: "سفارتخانه",
            key: 93990003
        },
        {
            value: "دفاتر پلیس + 10",
            key: 93990004
        },
        {
            value: "دفاتر ICT روستایی",
            key: 93990005
        },
        {
            value: "شهرداری",
            key: 93990006
        },
        {
            value: "دفاتر امور مشترکین",
            key: 93990007
        },
        {
            value: "دفاتر کفالت و اتباع خارجی",
            key: 93990008
        },
        {
            value: "سازمان تعزیرات حکومتی",
            key: 93990009
        },
        {
            value: "سازمان ثبت احوال",
            key: 93990010
        },
        {
            value: "مرکز تعویض پلاک",
            key: 93990011
        },
        {
            value: "سازمان پزشکی قانونی",
            key: 93990012
        },
        {
            value: "سازمان آتش نشانی",
            key: 93990013
        },
        {
            value: "مرکز معاینه فنی خودرو",
            key: 93990014
        },
        {
            value: "دفاتر خدمات الکترونیک شهر",
            key: 93990015
        },
        {
            value: "دهیاری",
            key: 93990016
        },
        {
            value: "شورایاری ",
            key: 93990017
        },
        {
            value: "جمع آوری وجوه دولتی",
            key: 94050000
        },
        {
            value: "قوه قضاييه",
            key: 98000000
        },
        {
            value: "ثبت اسناد و املاک کشور",
            key: 98010000
        },
        {
            value: "کسب و کارهای ویژه",
            key: 98030000
        },
        {
            value: "سازمان نظام مهندسی",
            key: 85000001
        },
        {
            value: "کمیته امداد",
            key: 83980001
        },
        {
            value: "موسسات خیریه",
            key: 83980002
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "فروشگاه ساعت",
            key: 59440001
        },
        {
            value: "فروشگاه نقره",
            key: 59440002
        },
        {
            value: "طراحی و ساخت طلا و جواهر",
            key: 59440003
        },
        {
            value: "فروشگاه طلا و جواهرآلات و سنگ های قیمتی",
            key: 59440004
        },
        {
            value: "خرده فروشی سکه طلا",
            key: 59440005
        },
        {
            value: "عمده فروشی طلا و جواهرآلات",
            key: 50940001
        },
        {
            value: "عمده فروشی ساعت",
            key: 50940002
        },
        {
            value: "عمده فروشی نقره",
            key: 50940003
        },
        {
            value: "تعمیرگاه ساعت مچی و دیواری",
            key: 76310001
        },
        {
            value: "تعمیرگاه اشیا قیمتی و نقره جات",
            key: 76310002
        },
        {
            value: "فروشگاه‌ سکه و تمبر کلکسیونی",
            key: 59720001
        },
        {
            value: "فروشگاه‌ سمساری و دسته دوم فروشی",
            key: 59310000
        },
        {
            value: "عتیقه فروشی (فروش، تعمیر و بازسازی)",
            key: 59320000
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "فروشگاه محصولات رسانه‌ای",
            key: 57350000
        },
        {
            value: "فروشگاه اینترنتی محصولات دیجیتال (کتاب، فیلم، موسیقی)",
            key: 58150000
        },
        {
            value: "تلویزیون‌های اینترنتی",
            key: 48990001
        },
        {
            value: "پادکست‌ها",
            key: 48990002
        },
        {
            value: "ویدیوکست‌ها",
            key: 48990003
        },
        {
            value: "فروشگاه اینترنتی بازی‌های دیجیتال",
            key: 58160000
        },
        {
            value: "فروش کنسول‌های بازی",
            key: 79930001
        },
        {
            value: "فروش بازی‌های کامپیوتری و ویدیوئی",
            key: 79930002
        },
        {
            value: "گیم‌نت",
            key: 79940000
        },
        {
            value: "فروشگاه لوازم و ادوات موسیقی",
            key: 57330000
        },
        {
            value: "فروشگاه اسباب بازی و وسایل سرگرمی",
            key: 59450000
        },
        {
            value: "تولید کارت، پاکت، جعبه و محصولات کاغذی و مقوایی",
            key: 59470001
        },
        {
            value: "فروش وسایل کادویی و تزئینی",
            key: 59470002
        },
        {
            value: "سایر کسب و کارهای مرتبط با این گروه صنفی",
            key: 59700000
        },
        {
            value: "فروشگاه صنایع دستی",
            key: 59700001
        },
        {
            value: "صنایع دستی پارچه ای",
            key: 59700002
        },
        {
            value: "سفال، سنگی، کاشی و سرامیک",
            key: 59700003
        },
        {
            value: "مصنوعات و ظروف فلزی",
            key: 59700004
        },
        {
            value: "مصنوعات چوبی و حصیری",
            key: 59700005
        },
        {
            value: "شیشه و آبگینه",
            key: 59700006
        },
        {
            value: "مصنوعات چرم دست دوز و طبیعی",
            key: 59700007
        },
        {
            value: "فروش مواد اولیه، دستگاه‌ها و ملزومات صنایع دستی",
            key: 59700008
        },
        {
            value: "گالری هنری",
            key: 59710001
        },
        {
            value: "طراحی و گرافیک و نقاشی",
            key: 59710002
        },
        {
            value: "خطاطی و تابلونویسی",
            key: 59710003
        },
        {
            value: "فروشگاه کالاهای مذهبی",
            key: 59730000
        },
        {
            value: "استودیو عکاسی",
            key: 72210000
        },
        {
            value: "خدمات عکاسی و گرافیک تجاری",
            key: 73330000
        },
        {
            value: "لابراتور ظهور عکس و فیلم",
            key: 73950000
        },
        {
            value: "تولید و پخش فیلم و محصولات چندرسانه‌ای",
            key: 78290000
        },
        {
            value: "سینما",
            key: 78320000
        },
        {
            value: "تهیه‌کنندگان تئاتر و آژانس‌های فروش بلیط تئاتر",
            key: 79220000
        },
        {
            value: "ارکستر و گروه موسیقی",
            key: 79290001
        },
        {
            value: "برگزارکنندگان کنسرت",
            key: 79290002
        },
        {
            value: "پارک آبی",
            key: 79990001
        },
        {
            value: "اجاره‌دهندگان هواپیماهای تفریحی، چتربازی، پاراگلایدر، وینگسوت و لوازم پروازهای تفریحی",
            key: 79990002
        },
        {
            value: "اجاره دهندگان دوچرخه",
            key: 79990003
        },
        {
            value: "اجاره دهندگان موتورسیکلت‌های تفریحی",
            key: 79990004
        },
        {
            value: "پیست اسکی",
            key: 79990005
        },
        {
            value: "پیست اسکیت",
            key: 79990006
        },
        {
            value: "سالن تیراندازی (تفریحی)",
            key: 79990007
        },
        {
            value: "موسسات اجاره خودروهاي تفريحاتي و خانه‌هاي متحرک",
            key: 79990008
        },
        {
            value: "خدمات مجالس و تشریفات",
            key: 72990001
        },
        {
            value: "تالارهای پذیرایی",
            key: 72990002
        },
        {
            value: "خدمات تبلیغات و بازاریابی",
            key: 73110000
        },
        {
            value: "اجاره کشتی‌ و قایق تفریحی",
            key: 44110000
        },
        {
            value: "اجاره قایق و جت اسکی",
            key: 44570000
        },
        {
            value: "تورهای مسافرتی و خدمات گردشگری",
            key: 47220000
        },
        {
            value: "فروش تریلرهای تفریحی و مسافرتی",
            key: 55610000
        },
        {
            value: "موزه‌ و نمایشگاه هنری",
            key: 79910001
        },
        {
            value: "جاذبه های گردشگری",
            key: 79910002
        },
        {
            value: "با‌غ و موزه گیاه‌شناسی",
            key: 79910003
        },
        {
            value: "نمایشگاه گردشگری",
            key: 79910004
        },
        {
            value: "سیرک",
            key: 79960001
        },
        {
            value: "شهربازی",
            key: 79960002
        },
        {
            value: "آکواریوم عمومی، باغ‌وحش و استخرهای نمایش دلفین",
            key: 79980001
        },
        {
            value: "مسافرخانه و مهمانپذیر و پانسیون",
            key: 70110001
        },
        {
            value: "هتل",
            key: 70110002
        },
        {
            value: "متل (راه‌سرا)",
            key: 70110003
        },
        {
            value: "پارک‌های جنگلی",
            key: 70110004
        },
        {
            value: "فروشگاه لوازم و کالای ورزشی",
            key: 59410001
        },
        {
            value: "لوازم صید و شکار",
            key: 59410002
        },
        {
            value: "تجهیزات سفر و کمپینگ",
            key: 59410003
        },
        {
            value: "چادر مسافرتی، خیمه و پشه‌بند",
            key: 59980000
        },
        {
            value: "استادیوم ورزشی",
            key: 79410001
        },
        {
            value: "باشگاه‌های ورزشی حرفه‌ای و قهرمانی",
            key: 79410002
        },
        {
            value: "سایر کسب و کارهای مرتبط با این گروه صنفی",
            key: 79970000
        },
        {
            value: "باشگاه بدنسازی و پرورش اندام",
            key: 79970001
        },
        {
            value: "باشگاه تنیس",
            key: 79970002
        },
        {
            value: "مجتمع و باشگاه‌ ورزشی",
            key: 79970003
        },
        {
            value: "باشگاه تیراندازی",
            key: 79970004
        },
        {
            value: "باشگاه سوارکاری",
            key: 79970005
        },
        {
            value: "باشگاه صخره نوردی",
            key: 79970006
        },
        {
            value: "باشگاه چتر بازی و پاراگلایدر",
            key: 79970007
        },
        {
            value: "زمین و باشگاه گلف",
            key: 79970008
        },
        {
            value: "سالن بیلیارد و اسنوکر",
            key: 79970009
        },
        {
            value: "سالن بولینگ",
            key: 79970010
        },
        {
            value: "اردوگاه ورزشی و تفریحی",
            key: 70320000
        },
        {
            value: "مهد کودک",
            key: 83510001
        },
        {
            value: "مدارس ابتدایی",
            key: 82110001
        },
        {
            value: "متوسطه اول و دوم",
            key: 82110002
        },
        {
            value: "مجتمع آموزشی",
            key: 82110003
        },
        {
            value: "هنرستان",
            key: 82110004
        },
        {
            value: "مدارس دانش آموزان استثنایی",
            key: 82110005
        },
        {
            value: "دانشگاه دولتی",
            key: 82200001
        },
        {
            value: "دانشگاه آزاد",
            key: 82200002
        },
        {
            value: "دانشگاه غیرانتفاعی",
            key: 82200003
        },
        {
            value: "دانشگاه جامع علمی کاربردی",
            key: 82200004
        },
        {
            value: "دانشگاه پیام ‌نور",
            key: 82200005
        },
        {
            value: "دانشگاه علوم پزشکی",
            key: 82200006
        },
        {
            value: "مرکز تربیت معلم",
            key: 82200007
        },
        {
            value: "دانشگاه پردیس خودگردان",
            key: 82200008
        },
        {
            value: "مراکز آموزشی مجازی",
            key: 82410000
        },
        {
            value: "آموزشگاه خیاطی و طراحی دوخت",
            key: 82490001
        },
        {
            value: "آموزشگاه آرایشگری و پیرایشگری",
            key: 82490002
        },
        {
            value: "آموزشگاه کامپیوتر (سخت افزار - نرم افزار)",
            key: 82490003
        },
        {
            value: "آموزشگاه رباتیک",
            key: 82490004
        },
        {
            value: "آموزشگاه تعمیرات موبایل",
            key: 82490005
        },
        {
            value: "آموزشگاه خلبانی",
            key: 82490006
        },
        {
            value: "آموزشگاه برق",
            key: 82490007
        },
        {
            value: "آموزشگاه فرش، قالیبافی و تابلوفرش",
            key: 82490008
        },
        {
            value: "آموزشگاه‌ زبان‌های خارجی",
            key: 82990001
        },
        {
            value: "آموزشگاه‌ هنر و موسیقی",
            key: 82990002
        },
        {
            value: "آموزشگاه رانندگی",
            key: 82990003
        },
        {
            value: "آموزشگاه درسی و کنکور",
            key: 82990004
        },
        {
            value: "مجتمع آموزشگاهی بزرگ و چند منظوره",
            key: 82990005
        },
        {
            value: "چاپ خانه داران",
            key: 27410001
        },
        {
            value: "خدمات نشر",
            key: 27410002
        },
        {
            value: "خدمات تایپ و ترجمه",
            key: 27410003
        },
        {
            value: "صحافی، دفتر و آلبوم سازی",
            key: 27410004
        },
        {
            value: "حروف‌چینی، لیتوگرافی و ماشین تحریر",
            key: 27910000
        },
        {
            value: "مهر و آرم و چاپ اسکرین",
            key: 73380001
        },
        {
            value: "خدمات فتوکپی، زیراکس و اوزالید",
            key: 73380002
        },
        {
            value: "عمده فروشان کاغذ، اوراق اداری و مواد مصرفی فتوکپی",
            key: 51110001
        },
        {
            value: "عمده فروشان  لوازم التحریر",
            key: 51110002
        },
        {
            value: "فروشگاه لوازم التحریر",
            key: 59430000
        },
        {
            value: "توزیع کنندگان عمده کتاب، روزنامه، مجله و گاهنامه",
            key: 51920001
        },
        {
            value: "کتاب فروشی",
            key: 59420001
        },
        {
            value: "کتابخانه",
            key: 59420002
        },
        {
            value: "دکه روزنامه فروشی",
            key: 59940000
        },
        {
            value: "نمايشگاه كتاب",
            key: 97000000
        },
        {
            value: "عنوان صنف تکمیلی",
            key: "کد صنف تکمیلی"
        },
        {
            value: "تعمیر موبایل و لوازم جانبی",
            key: 76290001
        },
        {
            value: "نصابان دوربین مداربسته و سیستم های امنیتی",
            key: 73930001
        },
        {
            value: "آژانس حفاظتی و امنیتی",
            key: 73930002
        },
        {
            value: "ارائه دهندگان خدمات محافظ شخصی",
            key: 73930003
        },
        {
            value: "تعلیم، آموزش و فروش سگ‌های نگهبان",
            key: 73930004
        },
        {
            value: "اسکورت و حمل محموله",
            key: 73930005
        },
        {
            value: "فروش انواع گاوصندوق و سکیوریتی باکس",
            key: 73930006
        },
        {
            value: "فروشندگان تلفن همراه و تجهیزات جانبی",
            key: 48120001
        },
        {
            value: "فروشندگان تلفن، دستگاه و تجهیزات مخابراطی",
            key: 48120002
        },
        {
            value: "فروش اینترنتی شارژ تلفن همراه",
            key: 48140000
        },
        {
            value: "ارائه دهندگان خدمات شبکه کامپیوتری",
            key: 48160001
        },
        {
            value: "ارائه دهنده خدمات اینترنت",
            key: 48160002
        },
        {
            value: "فروش دوربین و تجهیزات عکاسی و فیلم برداری",
            key: 59460001
        },
        {
            value: "تعمیرات دوربین و تجهیزات عکاسی و فیلم برداری",
            key: 59460002
        },
        {
            value: "فروشگاه تجهیزات الکترونیکی (به جز لوازم خانگی)",
            key: 57320001
        },
        {
            value: "عمده فروشی و پخش لوازم و ماشین‌های اداری",
            key: 50440000
        },
        {
            value: "عمده فروشی لپ تاپ، کامپیوتر",
            key: 50450001
        },
        {
            value: "عمده فروشی قطعات کامپیوتر و لوازم مرتبط",
            key: 50450002
        },
        {
            value: "عمده فروشی لوازم جانبی (کاور،کیف لپ تاپ)",
            key: 50450003
        },
        {
            value: "کافی نت",
            key: 73790001
        },
        {
            value: "تعمیرات و خدمات کامپیوتری",
            key: 73790002
        },
        {
            value: "فروشگاه‌ نرم افزار کامپیوتری",
            key: 57340000
        },
        {
            value: "کالاهای دیجیتال (نرم افزارهای کاربردی، به غیر از بازی)",
            key: 58170000
        },
        {
            value: "فروش کالاهای دیجیتال",
            key: 58180000
        },
        {
            value: "خدمات برنامه نویسی و طراحی سایت",
            key: 73720000
        },
        {
            value: "بازارگاه آنلاین",
            key: 52620001
        },
        {
            value: "خرید و فروش آنلاین طلا",
            key: 60080002
        },
    ]